import { useEffect, useState } from 'react';

export default function useIsMobile(breakpoint = 768) {
  const getMatch = () => {
    if (typeof window === 'undefined' || !window.matchMedia) return false;
    return window.matchMedia(`(max-width: ${breakpoint}px)`).matches;
  };

  const [isMobile, setIsMobile] = useState(getMatch);

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return undefined;
    const media = window.matchMedia(`(max-width: ${breakpoint}px)`);
    const handler = (event) => setIsMobile(event.matches);
    setIsMobile(media.matches);

    if (media.addEventListener) {
      media.addEventListener('change', handler);
      return () => media.removeEventListener('change', handler);
    }
    media.addListener(handler);
    return () => media.removeListener(handler);
  }, [breakpoint]);

  return isMobile;
}
